import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { alpha, darken, styled } from '@mui/material/styles';

export const toolTextSx = { fontSize: { xs: '0.65rem', sm: '0.7rem' }, lineHeight: 1.9, textAlign: 'left' };

export const ToolButton = styled(Button)(({ theme }) => ({
  margin: 0, minHeight: 46, padding: '10px 18px', borderRadius: 18,
  border: `2px solid ${theme.palette.primary.main}`,
  fontSize: '0.7rem', lineHeight: 1.8, color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.default,
  boxShadow: `0 5px 0 ${darken(theme.palette.primary.main, 0.65)}`,
  transition: 'transform 140ms ease, box-shadow 140ms ease',
  '&.MuiButton-contained': {
    color: theme.palette.background.default,
    background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
    boxShadow: `0 5px 0 ${darken(theme.palette.primary.main, 0.6)}, 0 0 20px ${alpha(theme.palette.primary.main, 0.2)}`,
  },
  '&:hover': {
    color: theme.palette.primary.main, backgroundColor: alpha(theme.palette.primary.main, 0.12),
    transform: 'translate(-1px, -2px)', boxShadow: `1px 7px 0 ${darken(theme.palette.primary.main, 0.65)}`,
  },
  '&.MuiButton-contained:hover': { color: theme.palette.background.default },
  '&:active': { transform: 'translateY(4px)', boxShadow: 'none' },
  '&:focus-visible': { outline: `2px solid ${theme.palette.secondary.main}`, outlineOffset: 4 },
  '&.Mui-disabled': { opacity: 0.4 },
  '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } },
}));

export default function ToolCard({ id, title, icon, action, children }) {
  return (
    <Box component="section" aria-labelledby={id} sx={(theme) => ({
      minWidth: 0, p: { xs: 2.5, sm: 3 }, borderRadius: '32px',
      border: `3px solid ${theme.palette.primary.main}`,
      background: `linear-gradient(110deg, ${theme.palette.background.default} 55%, ${alpha(theme.palette.primary.main, 0.08)})`,
      boxShadow: `0 6px 0 ${darken(theme.palette.secondary.main, 0.65)}, 0 8px 24px ${alpha(theme.palette.secondary.main, 0.18)}`,
    })}>
      <Stack direction="row" alignItems="center" gap={1.5} sx={{ mb: 2 }}>
        <Box aria-hidden="true" sx={{ color: 'secondary.main', display: 'flex' }}>{icon}</Box>
        <Typography component="h2" id={id} sx={{ fontSize: { xs: '0.78rem', sm: '0.9rem' }, lineHeight: 1.8, textAlign: 'center', flex: 1, m: 0 }}>{title}</Typography>
        {action}
      </Stack>
      {children}
    </Box>
  );
}
